import VueMask from 'v-mask';
import GooglePlacesAPI from './plugins/google-places';

// Base
import AnchorBase from './components/base/Base';
// User
import AnchorUserMenu from './components/user/Menu';
// Utils
import AnchorAttributeDisplay from './components/utils/AttributeDisplay';
import AnchorConfirmDialog from './components/utils/ConfirmDialog';
import AnchorLoader from './components/utils/Loader';
import AnchorLogo from './components/utils/AnchorLogo';
import AnchorModal from './components/utils/Modal';
import AnchorModalTable from './components/utils/ModalTable';
import AnchorNotFound from './components/utils/NotFound';
import AnchorRecordCounter from './components/utils/RecordCounter';
import AnchorResultsDisplay from './components/utils/ResultsDisplay';
import AnchorRightContent from './components/utils/RightContent';
import AnchorSearchParams from './components/utils/SearchParams';
import AnchorSimpleLink from './components/utils/SimpleLink';
import AnchorTabs from './components/utils/Tabs';
// Utils -> Buttons
import AnchorTooltipBtn from './components/utils/buttons/TooltipBtn';
// Utils -> Cards -> Sidebar
import AnchorSidebarBaseCard from './components/utils/cards/sidebar/BaseCard';
import AnchorSidebarBaseSplitCard from './components/utils/cards/sidebar/BaseSplitCard';
// Utils -> Cards -> View
import AnchorCardBaseView from './components/utils/cards/view/BaseViewCard';
import AnchorResultsCard from './components/utils/cards/view/ResultsCard';
import AnchorCardTitleCheckbox from './components/utils/cards/view/TitleCheckbox';
// Utils -> Checklist
import AnchorChecklistLegend from './components/utils/checklist/ChecklistLegend';
import AnchorChecklistModal from './components/utils/checklist/ChecklistModal';
import AnchorChecklistTable from './components/utils/checklist/ChecklistTable';
// Utils -> Chips
import AnchorChipItem from './components/utils/chips/ChipItem';
import AnchorChipList from './components/utils/chips/ChipList';
import AnchorChipMenu from './components/utils/chips/ChipMenu';
// Utils -> Files
import AnchorFilesContainer from './components/utils/files/FilesContainer';
import AnchorFilesUploader from './components/utils/files/FilesUploader';
import AnchorApproveRejectFile from './components/utils/files/ApproveRejectFile';
import AnchorApproveRejectModal from './components/utils/files/ApproveRejectModal';
import AnchorBaseInsightExpansionPanel from './components/utils/files/BaseInsightExpansionPanel';
import AnchorFileActions from './components/utils/files/FileActions';
import AnchorFilesTable from './components/utils/files/FilesTable';
// Utils -> Form
import AnchorAddressForm from './components/utils/form/AddressForm';
import AnchorBaseForm from './components/utils/form/BaseForm';
import AnchorCheckbox from './components/utils/form/AnchorCheckbox';
import AnchorPhoneField from './components/utils/form/AnchorPhoneField';
import AnchorSelect from './components/utils/form/AnchorSelect';
import AnchorSsnField from './components/utils/form/AnchorSsnField';
import AnchorTextarea from './components/utils/form/AnchorTextarea';
import AnchorTextField from './components/utils/form/AnchorTextField';
import AnchorDatePickerInput from './components/utils/form/DatePickerInput';
import AnchorFormBaseCard from './components/utils/form/FormBaseCard';
import AnchorFormButtons from './components/utils/form/FormButtons';
import AnchorListSelect from './components/utils/form/ListSelect';
import AnchorSplitForm from './components/utils/form/SplitForm';
// Utils -> Sidebar
import AnchorSidebarItem from './components/utils/sidebar/Item';
import AnchorSidebarDivider from './components/utils/sidebar/Divider';
import AnchorRouterMenu from './components/utils/sidebar/RouterMenu';
import AnchorRouterInputMenu from './components/utils/sidebar/RouterInputMenu';
import AnchorSidebarQuickLinks from './components/utils/sidebar/QuickLinks';
// Utils -> Wrappers
import AnchorDataTable from './components/utils/wrappers/DataTable';

import requests from './plugins/requests';
import servers from './plugins/servers';
import filters from './plugins/filters';
import utils from './plugins/utils';


const Components = {
  // Base
  AnchorBase,
  // User
  AnchorUserMenu,
  // Utils
  AnchorAttributeDisplay,
  AnchorLoader,
  AnchorLogo,
  AnchorModal,
  AnchorModalTable,
  AnchorNotFound,
  AnchorRecordCounter,
  AnchorResultsDisplay,
  AnchorRightContent,
  AnchorSearchParams,
  AnchorSimpleLink,
  AnchorConfirmDialog,
  AnchorTabs,
  // Utils -> Buttons
  AnchorTooltipBtn,
  // Utils -> Cards -> Sidebar
  AnchorSidebarBaseCard,
  AnchorSidebarBaseSplitCard,
  // Utils -> Cards -> View
  AnchorCardBaseView,
  AnchorResultsCard,
  AnchorCardTitleCheckbox,
  // Utils -> Checklist
  AnchorChecklistLegend,
  AnchorChecklistModal,
  AnchorChecklistTable,
  // Utils -> Chips
  AnchorChipItem,
  AnchorChipList,
  AnchorChipMenu,
  // Utils -> Files
  AnchorFilesContainer,
  AnchorFilesUploader,
  AnchorApproveRejectFile,
  AnchorApproveRejectModal,
  AnchorBaseInsightExpansionPanel,
  AnchorFileActions,
  AnchorFilesTable,
  // Utils -> Form
  AnchorAddressForm,
  AnchorBaseForm,
  AnchorCheckbox,
  AnchorPhoneField,
  AnchorSelect,
  AnchorSsnField,
  AnchorTextarea,
  AnchorTextField,
  AnchorDatePickerInput,
  AnchorFormBaseCard,
  AnchorFormButtons,
  AnchorListSelect,
  AnchorSplitForm,
  // Utils -> Sidebar
  AnchorSidebarItem,
  AnchorSidebarDivider,
  AnchorRouterMenu,
  AnchorRouterInputMenu,
  AnchorSidebarQuickLinks,
  // Utils -> Wrappers
  AnchorDataTable,
};


const VueAssetsPlugin = {
  install(Vue, { googleApiKey } = {}) {
    Vue.use(VueMask);

    if (googleApiKey) {
      Vue.use(GooglePlacesAPI, { key: googleApiKey });
    }

    Object.keys(Components).forEach(name => {
      Vue.component(name, Components[name]);
    });

    Vue.use(requests);
    Vue.use(servers);
    Vue.use(filters);
    Vue.use(utils);
  },
};

export default VueAssetsPlugin;
